var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPercentUp(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.3951 10.5367C12.6916 10.3183 12.7549 9.901 12.5366 9.60454C12.367 9.37427 12.1974 9.15538 12.0486 8.96474C11.7516 8.58416 11.3427 8.07447 10.8985 7.56283C10.4571 7.0545 9.96774 6.52899 9.51088 6.12533C9.28321 5.92417 9.04791 5.73917 8.81846 5.60085C8.60732 5.47356 8.31719 5.33325 7.99977 5.33325C7.68235 5.33325 7.3922 5.47356 7.18105 5.60085C6.9516 5.73917 6.7163 5.92417 6.48863 6.12533C6.03177 6.52899 5.54242 7.0545 5.10106 7.56283C4.65682 8.07447 4.24794 8.58416 3.95093 8.96474C3.80215 9.15538 3.63252 9.37427 3.46292 9.60454C3.24458 9.901 3.30791 10.3183 3.60437 10.5367C3.72354 10.6244 3.86225 10.6667 3.99972 10.6666L7.99976 10.6666L11.9998 10.6666C12.1373 10.6667 12.276 10.6244 12.3951 10.5367Z",
    fill: "#138644"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPercentUp);
export default __webpack_public_path__ + "static/media/percent_up.6171ddf24f5dd9dbc7701b4eb5df427e.svg";
export { ForwardRef as ReactComponent };